import React from 'react';
import {Animated} from 'react-animated-css'

// styling
import './assessments.css';

const AssessmentQuestion = props => {
    return (
      <Animated animationIn="slideInRight" animationOut="slideOutLeft" isVisible={true} animationInDuration={800}>
        <p className="quiz-styling"><span style={{color: '#ff0033'}}>{props.qnNumber}. </span>  {props.content} <br/> <span style={{color: "#ff0033", fontStyle: "normal"}}> _</span></p>

      </Animated>
      );
};

export default AssessmentQuestion;


// WEBPACK FOOTER //
// ./src/common/assessmentQuestion.Component.tsx